module.exports = __webpack_public_path__ + "img/album5.03884e09.jpg";